<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Chapter Three</h1>
</div>
</div>
<blockquote>
<p class="first">
		“<i>Matt Klein and I make a great team because we share a vision to provide safe accommodations for overweight children. It also helps that we’ve been best friends since third grade.”</i></p>
<p class="first" style="text-align: right;">
<i>Jack Moskowitz, </i>strollersavvy.com<i> </i></p>
</blockquote>
<h1>
	Chapter Three</h1>
<p class="sectiontop">
	“What the fuck, Lauren?!” Jack waited till they were safely out of microphone and camera range before tearing into her.</p>
<p>
	“What?” Lauren handed him the hot pink swag bag that was crammed with gourmet dog biscuits, organic dog shampoo and PCB-free dog toys.</p>
<p>
	“How could you throw me under the bus like that?”</p>
<p>
	“Be happy I got you a date. Now you don’t have to worry about Mom trying to set you up with that loser friend of hers.” Lauren pulled Diesel towards the crosswalk. The hyped up dog wasn’t anywhere near as eager to leave the party as Jack was.</p>
<p>
	“And Horowitz? Seriously?”</p>
<p>
	“What? You totally needed a fake identity.”</p>
<p>
	“Where did you even come up with that name?”</p>
<p>
	“You know that annoying boy who sits behind me in orchestra? The one who smells like Doritos? It’s his last name.”</p>
<p>
	“Thanks a lot.”</p>
<p>
	“It was the closest thing to your real name. I figured you wouldn’t forget it that way.” Lauren tugged on the leash again. “Come on, Diesel. Quit being so stubborn.”</p>
<p>
	“Either way, I don’t need my ten-year-old niece setting me up on dates. I’m not that desperate—yet.” Jack reached for the leash. “Give him to me.”</p>
<p>
	“It’s better than mom doing it. Trust me. That friend of hers she was trying to get you to go out with is a total freak. She eats her hair—literally. They just had to cut it up to her chin at her last photo shoot ‘cause the ends were so ratty.”</p>
<p>
	“At least your mom didn’t try to set me up with someone who just tore me apart on national television.” Jack gave up on pulling the reluctant dog away from the park and picked him up.</p>
<p>
	“She didn’t say anything bad about you. She was just talking about Considerable Carriages.”</p>
<p>
	“Same difference. It’s my company.” Jack carried the wriggling handful of fur across the street.</p>
<p>
	“<i>You</i> don’t even think you should make the new gigantic strollers.”</p>
<p>
	“What? Why would you think that?”</p>
<p>
	“I heard you and Matt fighting about it last week.”</p>
<p>
	“You shouldn’t have been eavesdropping.” Jack reached his elbow out for Lauren to hold on to while they crossed the street.</p>
<p>
	“I wasn’t eavesdropping. You guys were being loud.”</p>
<p>
	Jack shook his head.</p>
<p>
	“You were right. These strollers for super fat kids are a really bad idea,” Lauren continued.</p>
<p>
	“It’s not that simple.” As soon as they hit the sidewalk again, Jack plopped Diesel on the ground and dragged him farther away from the dog park.</p>
<p>
	As they got closer, Jack noticed the sun resting above the bright blue Chelsea Piers Fieldhouse. He felt a vibration in his pocket and reached for his phone, unsure if he had an incoming call or it was the cars rushing by.</p>
<p>
	“Hey man, since we’re going with the snack tray, we might as well add the large cup holder.” Matt started talking as soon as Jack picked up.</p>
<p>
	“I’m still thinking through the concept.”</p>
<p>
	“You better think fast. We need to do this before Maclaren beats us to the punch,” Matt practically screamed over the Linkin Park blasting in the background.</p>
<p>
	“Listen, you’re not going to believe who I ran into at the dog park.”</p>
<p>
	“Not that dog walker I slept with? I think she’s stalking me. I swear I saw her waiting for me outside my building the other day.” Matt sighed as if he was annoyed, but Jack knew having a possible stalker was a real ego boost for his friend.</p>
<p>
	“It was Kate Richards.”</p>
<p>
	“Did you tear her a new one?” Matt lowered his music.</p>
<p>
	“No, I saved her dog from getting attacked by a German Shepherd.”</p>
<p>
	“You should’ve let that fem-bot’s dog get eaten. Would serve her right.” Matt’s voice remained loud even though his music was barely audible now.</p>
<p>
	“Come on. It’s not the poor dog’s fault her owner has such a big mouth.”</p>
<p>
	“Lemme guess. It was a MaltiPoo or a Shih Tzu.”</p>
<p>
	“Actually, she has a really cool Boston. Anyway, I saved the dog and long story short, I’m supposed to meet up with Kate Richards for dinner.”</p>
<p>
	“Why would she ask the evil fat kid stroller guy out to dinner?”</p>
<p>
	“She has no idea who I am.”</p>
<p>
	“Bullshit! She blasted our company on <i>Straight Talk</i> less than forty-eight hours ago.”</p>
<p>
	“That doesn’t mean she knows who I am. You’re the face of the company, not me.”</p>
<p>
	“That’s because I have the better looking face.”</p>
<p>
	“No, asshole. It’s ‘cause you have the bigger ego.”</p>
<p>
	“Jack Moskowitz isn’t the most common name out there. That must’ve clued her in.”</p>
<p>
	“That’s why my genius niece decided to introduce me as Jack Horowitz, named after the stinky kid from orchestra.”</p>
<p>
	“I still don’t get why you agreed to go.”</p>
<p>
	“Lauren said yes for me. And I couldn’t make a big scene with the <i>KidFit</i> film crew there.”</p>
<p>
	Matt was uncharacteristically slow with a comeback.</p>
<p>
	“I just haven’t decided if I should stand her up or if I should go explain who I am,” continued Jack. “Did I mention she’s pretty fuckin’ hot when she’s not talking about strollers?”</p>
<p>
	“Haven’t you ever heard that saying about keeping your friends close but your enemies closer? You’re going on that date.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap240842.vue?702e01ef